import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router-dom'
import { connect } from 'react-redux'

class Pager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1
        }
        this.totalCount = this.props.totalCount;
        this.clickHandler = this.props.clickHandler;
        if(this.props.currentPage) {
            this.state.currentPage = parseInt(this.props.currentPage);
        }
    }
    clickPage(pageNum) {
        this.setState({ currentPage: pageNum});
        this.clickHandler(pageNum);
    }
    render() {
        console.log("pager rendered with props " );
        console.log(this.props);
        var numPages = Math.ceil(this.props.totalCount / this.props.pageSize);
        console.log("numPages "+numPages);
        var i;
        var pages = Array();
        for(i=1;i<=numPages;i++) {
            pages.push(i);
        }
        var min = (this.state.currentPage < 10)? 0: this.state.currentPage-10;
        var max = (this.state.currentPage < 10)? 20: this.state.currentPage+10;
        var output = pages.map((page) => {
            var classes = "pager";
            if(min < page && page <= max) {
//                console.log("entering first if with "+page);
//                console.log("when this.state.currentPage is "+this.state.currentPage);
//                console.log(this.state.currentPage+10);
                if(page < this.state.currentPage+10) {
//                    console.log("how is "+page+" smaller than "+(this.state.currentPage+10));
                }
                if(page == this.state.currentPage) {
                    classes += ' active';
                }
                return (<span key={page} className={classes} onClick={this.clickPage.bind(this, page)}>{page}</span>);    
            } else {
                return null;
            }
        });
        return (
            <div className="pagerWrapper">
                {(numPages > 0)?
                <span key="firstPage" className="pager" onClick={this.clickPage.bind(this, 1)}>First</span>
                : ''}
                    {output}
                {(numPages > 0)?
                <span key="lastPage" className="pager" onClick={this.clickPage.bind(this, numPages)}>Last</span>
                : ''}
            </div>
        )
    }
}
export default (Pager);


// WEBPACK FOOTER //
// ./src/components/dashboards/Pager.js